<div class="container mainbox">
    <div>
        <h1 class="form-group title-position" translate>site-banner-management.create</h1>
        <form [formGroup]="addEditForm" (ngSubmit)="onSubmit()">
            <div class="card">
                <div class="card-body">
                    <div class="form-group form-row">
                        <div class="col">
                            <label translate>site-banner-management.uploadBanner</label>
                            <input type="file" formControlName="file" accept="image/png, image/jpeg, image/gif"
                                class="file-input" maxFileSize="5000000" (change)="onFileSelected($event)" />
                            <span class="invalid-format" *ngIf="invalidFileType" translate>Невалиден файл формат</span>
                            <div class="invalid-feedback" *ngIf="mainForm.file.errors?.required && showValidations"
                                translate>
                                errors.required
                            </div>
                        </div>
                    </div>

                    <div class="form-group form-row">
                        <div class="col">
                            <label translate>site-banner-management.filePath</label>
                            <input type="text" class="form-control" formControlName="filePath"
                                [ngClass]="{ 'is-invalid': showValidations && mainForm.filePath.errors }" readonly>
                        </div>
                    </div>

                    <br>
                    <div class="form-group form-row">
                        <div class="col">
                            <img height="400" width="1050" [src]="imageUrl" alt="Selected Image" *ngIf="imageUrl" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-right">
                <button class="btn btn-primary w-20 mt-2" type="submit" translate>button.save</button>
            </div>
        </form>

        <ng-template #loading>
            <div *ngIf="errorMessage$ | async as errorMessage; else spinner">
                <div class="alert alert-danger">
                    {{ errorMessage }}
                </div>
                <div class="d-flex justify-content-center">
                    <i class="fa fa-refresh" (click)="reload()"></i>
                </div>
            </div>
            <ng-template #spinner>
                <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </ng-template>
        </ng-template>
    </div>
</div>
